import { Card, Col, Form, message, Row, Typography, Upload } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { applyJobAsync, getPublishJobAsync } from "../../../Slices/hiringSlice";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AntdButton, InputField, SelectInput } from "../../../blueplanitUtils/InputField";
const { Paragraph } = Typography;

const JobApplyPage = () => {
    const { slug } = useParams();

    const dispatch = useDispatch();
    const publishJob = useSelector((state) => state.hiring.publishJob);

    console.log(publishJob)

    const [form] = Form.useForm();
    const [resumeUrl, setResumeUrl] = useState("");

    useEffect(() => {
        if (slug) {
            dispatch(getPublishJobAsync(slug))
        }

    }, [dispatch, slug])

    const requirements = publishJob?.requirements?.join(",")

    const [formData, setFormData] = useState({
        firstName:"",
        lastName:"",
        email:"",
        phone:"",
        experience:"",
        currentCTC:"",
        expectedCTC:"",
        appliedSlug:"",
        resumeUrl:"",
        source:""
    })

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSubmit = async () => {
        try {
            await dispatch(applyJobAsync({
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                phone: formData.phone,
                experience: formData.experience,
                currentCTC: formData.currentCTC,
                expectedCTC: formData.expectedCTC,
                resumeUrl,
                appliedSlug: slug,
                source:
                    formData.source ||
                    new URLSearchParams(window.location.search).get("source") ||
                    "Website"
            })
            );

            message.success("Application submitted successfully!");

            setResumeUrl("");
        } catch (error) {
            console.error(error);
            message.error("Failed to submit application.");
        }
    };

    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <Card title="Job Application" style={{ marginBottom: 20 }}>
                    <Card
                        type="inner"
                        title="Job Details"
                        style={{ marginBottom: 20 }}
                    >
                        <Row gutter={[16, 16]}>
                            <Col span={6}><b>Job Title:</b><span>{publishJob?.jobTitle}</span></Col>
                            <Col span={6}><b>Location:</b><span>{publishJob?.location}</span></Col>
                            <Col span={6}><b>Employment Type:</b><span>{publishJob?.employmentType}</span></Col>
                            <Col span={6}><b>Work Mode:</b><span>{publishJob?.workMode}</span></Col>
                            <Col span={6}><b>Salary Range:</b><span>{publishJob?.salaryRange}</span></Col>
                            <Col span={6}><b>Experience Required:</b><span>{publishJob?.experienceRequired}</span></Col>
                            <Col span={12}><b>Skills Required:</b><span>{requirements}</span></Col>
                            <Col span={12}><b>Responsibilities:</b><span>{publishJob?.responsibilities}</span></Col>
                            <Col span={12}><b>Description:</b><span>{publishJob?.description}</span></Col>

                        </Row>
                    </Card>
                    <Card type="inner" title="Apply for this Job">
                        <Row gutter={24}>
                            <Form form={form} layout="vertical" onFinish={handleSubmit}>
                                <Row gutter={[16, 16]}>
                                    <Col span={6}>
                                        <InputField 
                                        label="First Name"
                                        name="firstName" 
                                        placeholder="Enter First name"
                                        onChange={(e) => handleChange("firstName", e.target.value)}
                                         />
                                    </Col>
                                    <Col span={6}>
                                        <InputField
                                            label="Last Name"
                                            name="lastName"
                                            placeholder="Enter Last name"
                                            onChange={(e) => handleChange("lastName", e.target.value)}
                                             />
                                    </Col>

                                    <Col span={6}>
                                        <InputField
                                            label="Email"
                                            name="email"
                                            placeholder="Enter email"
                                            type="email" 
                                            onChange={(e) => handleChange("email", e.target.value)}
                                            />

                                    </Col>

                                    <Col span={6}>
                                        <InputField
                                            label="Phone"
                                            name="phone"
                                            placeholder="Enter phone number"
                                            onChange={(e) => handleChange("phone", e.target.value)} 
                                            />
                                    </Col>
                                    <Col span={6}>
                                        <SelectInput
                                            label="Source"
                                            name="source"
                                            value={publishJob?.publishedSources}
                                            options={[
                                                {label:"LinkedIn", value:"LinkedIn"},
                                                {label:"Indeed", value:"Indeed"},
                                                {label:"Naukri", value:"Naukri"}
                                        ]}
                                            placeholder="Enter First name"
                                           onChange={(value) => handleChange("source", value)} 
                                            style={{ width: '100%' }}
                                        />

                                    </Col>
                                    <Col span={6}>
                                        <InputField
                                            label="Experience"
                                            name="experience"
                                            placeholder="enter your experience"
                                            onChange={(e) => handleChange("experience", e.target.value)} 
                                            />
                                    </Col>
                                    <Col span={6}>
                                        <InputField
                                            label="Current CTC"
                                            name="currentCTC"
                                            onChange={(e) => handleChange("currentCTC", e.target.value)}
                                            placeholder="enter your current ctc" 
                                            />
                                    </Col>
                                    <Col span={6}>
                                        <InputField
                                            label="Expected CTC"
                                            name="expectedCTC"
                                            onChange={(e) => handleChange("expectedCTC", e.target.value)}
                                            placeholder="enter your expected your ctc" />
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="Upload your Resume">
                                            <Upload
                                                beforeUpload={(file) => {
                                                    // TODO: Replace with S3 upload logic
                                                    setResumeUrl(URL.createObjectURL(file));
                                                    message.success("Resume uploaded (demo mode)");
                                                    return false;
                                                }}
                                            >
                                                <AntdButton label="Upload Resume" />
                                            </Upload>

                                            {resumeUrl && (
                                                <Paragraph type="secondary">
                                                    Uploaded: {resumeUrl}
                                                </Paragraph>
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <AntdButton label="Submit Application" type="primary" htmlType="submit" size="large" />

                            </Form>
                        </Row>
                    </Card>

                </Card>
            </div>
        </div>
    )
};

export default JobApplyPage